<mat-checkbox class="cb pitka-label" [formField]="lomake.valittu" (change)="checkboxChangedEventHandler(lomake.valittu().value())">
  @if (order) {
    {{ order }})
  }
  {{ parent + '.' + field | translatetilinpaatos: 2021 | async }}
</mat-checkbox>
@if (info) {
  <app-icon-button (click)="avaaInfoTeksti(info)" actionId="Avaa info teksti (liitetiedot)" styles="vertical-align: middle; top: -3px;">
    <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray" aria-hidden="true"></i>
  </app-icon-button>
}
@if (saveSuccess) {
  <span>
    <span class="save-success-text" [@quickInSlowOut]="'in'" style="color: gray"> Arvo tallennettiin </span>
    <mat-icon class="save-success-icon" [@quickInSlowOut]="'in'" [ngStyle]="{ color: '#4bd76b', 'vertical-align': 'middle' }">done</mat-icon>
  </span>
}
<div style="height: 10px">
  @if (saving) {
    <div class="saving" style="height: 10px; width: 100%; padding: 0 33px" [@slowInQuickOut]="'in'">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
  @if (saveFailure) {
    <div>
      <span class="save-failure-text"> Tallentamisen aikana tapahtui virhe. Ole hyvä ja yritä uudelleen. </span>
      <mat-icon class="save-failure-icon" [ngStyle]="{ color: 'rgb(255, 72, 102)', 'vertical-align': 'middle' }">error_outline</mat-icon>
    </div>
  }
</div>
@if (liitetiedot.valitut[field]) {
  <div style="margin-left: 34px; padding-bottom: 10px">
    @if (type === 'text') {
      <textarea matInput style="border: 1px dashed gray; padding: 3px; width: 100%; font-family: inherit; font-size: 14px" (blur)="tallennaMuuttunutArvo()" [formField]="lomake.teksti" (input)="textChangedEventHandler($any($event.target).value)" cdkTextareaAutosize></textarea>
      @if (example) {
        <div [innerHTML]="example" style="padding: 8px; display: inline-block; color: gray"></div>
      }
    }
    @if (type === 'number') {
      <mat-form-field style="margin-top: 5px; width: 250px">
        <mat-label>{{ rawExample }}</mat-label>
        <input class="skip-space-quick-toggle" decimalNumberField #numberField type="text" (blur)="tallennaMuuttunutArvo()" [formField]="lomake.numero" (input)="numberChangedEventHandler(lomake.numero().value())" (change)="numberChangedEventHandler(lomake.numero().value())" matInput data-lpignore="true" />
      </mat-form-field>
    }
  </div>
}
